import { CONST } from "../CONST";

export default class BackButton extends Phaser.GameObjects.Image {
    constructor(pointsToScene: string, x: number, y: number, scene: Phaser.Scene, texture: string = CONST.BUTTONS.BACK){
        super(scene, x, y, texture);

        scene.storagePlugin.setItem("openArcadePopup", "1");
        this.setInteractive({useHandCursor: true});
        this.on("pointerup", ()=> {
            if (scene.rewardedBreakRequested) return;
            scene.scene.start(pointsToScene);
        });
        scene.add.existing(this);
    }
}